import React, { useEffect, useState } from 'react';
import { useIsMount } from '../../../hooks/useIsMountHook';
import i18n from '../../../i18n';
import 'components/transactionEditor/Wizards/BzmTreeTable.css';
import BzmTreeTable from './BzmTreeTable';
import _ from 'lodash';
import { getDataModelForService } from '../../../store/dataModel/dataModelActions';
import { ToastType } from '../../../store/ui/toasts/toastsTypes';
import { getErrorMessage } from '../../../utils/miscUtil';
import { useDispatch } from 'react-redux';
import { showToastNotification } from '../../../store/ui/toasts/toastsActions';
import { convertDataModelToTree } from '../../../utils/blazeDataUtils';
import FullPageLoader from '../../loaders/FullPageLoader';
import DataPreview from './DataPreview';

type DataParametersPanelProps = {
  onParameterSelected: (value: string) => void;
  serviceId?: number;
};

const DataParametersPanel = (props: DataParametersPanelProps) => {
  const isMount = useIsMount();
  const [data, setData] = useState<any[]>([]);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [dataModel, setDataModel] = useState<any>();

  useEffect(() => {
    if (isMount) {
      getDataModel();
    }
  }, []);

  const getDataModel = async () => {
    try {
      if (_.isNil(props.serviceId)) {
        throw new Error('Model not available');
      }
      const dataModel = await getDataModelForService(props.serviceId, true, true);
      const tree = convertDataModelToTree(dataModel);
      setData(tree);
      setDataModel(dataModel);
    } catch (error) {
      dispatch(
        showToastNotification(
          ToastType.Danger,
          'An error occurred during communication with Blaze Data.',
          getErrorMessage(error),
        ),
      );
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className={'mt-10 mb-10'}>
        <FullPageLoader loadingText={i18n.t('common:actions.loading')}></FullPageLoader>
      </div>
    );
  }

  const onSelect = (id: string) => {
    props.onParameterSelected('${' + id + '}');
  };

  return (
    <div>
      <BzmTreeTable
        data={data}
        parentChildData={(row, rows) => rows.find((a: any) => a.id === row.parentId)}
        columns={[
          {
            title: i18n.t('transactions:editor.name'),
            field: 'name',
            cellStyle: {
              width: '47%',
            },
            render: (row: any) => {
              if (row.type === 'NODE') {
                return <span className={'font-weight-normal non-hover'}>{row.name}</span>;
              } else {
                return (
                  <div className={'ml-5 cursor-pointer'} onClick={() => onSelect(row.id)}>
                    <span id={'leaf_' + row.id} className={'font-weight-normal text-dark'}>
                      {row.name}
                    </span>
                  </div>
                );
              }
            },
          },
          {
            title: i18n.t('transactions:editor.value'),
            cellStyle: {
              width: '47%',
            },
            render: (row: any) => {
              if (row.type === 'NODE') {
                return '';
              }

              return (
                <div className={'cursor-pointer'} onClick={() => onSelect(row.id)}>
                  <DataPreview
                    key={row.id}
                    id={row.id}
                    text={row.leafText}
                    entityName={row.parentId}
                    propertyName={row.id}
                    dataModel={dataModel}
                  />
                </div>
              );
            },
          },
        ]}
      ></BzmTreeTable>
    </div>
  );
};

export default DataParametersPanel;
